<template>
  <v-row
    :class="[
      'menu-box',
      'mx-0',
      'pa-1',
      {
        'menu-box-no-left-border': $vuetify.breakpoint.xsOnly && $store.getters.categoryPosition == 'left',
      },
    ]"
    @click="itemClicked(item)"
  >
    <div
      v-if="!$store.getters.storeMenuMode && getItemOrderedQty(item.ID) > 0"
      class="ordered-qty-right"
      :x-class="$store.state.menuImageAlignment == 'left' ? 'ordered-qty-left' : 'ordered-qty-right'"
    >
      {{ getItemOrderedQty(item.ID) }}
    </div>
    <v-col
      v-if="
        $store.state.menuImageAlignment != 'right' &&
          ($store.state.menuImageVisible == 'show' || ($store.state.menuImageVisible == 'auto' && item.imageUri != ''))
      "
      :class="[
        $store.getters.categoryPosition == 'left' && $vuetify.breakpoint.xsOnly ? 'menu-img-box-xs' : 'menu-img-box',
        'pa-0',
        'align-self-center',
      ]"
    >
      <div v-if="item.imageUri == ''"></div>
      <img v-else :src="item.imageUri" />
    </v-col>

    <v-col class="menu-content-box pa-0 px-1">
      <div :class="['item-content']">
        <div>
          {{ itemDescr }}
        </div>
        <div v-if="item != null && item.scalable && item.weight > 0" class="item-scale">
          {{ item.weight }} {{ item.weightUnit }} @ {{ item.price | currency }}
        </div>
        <div v-if="$store.state.showItemBarcode && item.barcode != ''" class="item-barcode">
          {{ item.barcode }}
        </div>
        <div v-if="itemDetail != ''" class="item-detail">
          {{ itemDetail }}
        </div>
        <!--         
        <div v-if="$store.state.descrIndex == 0">
          {{ item.descr }}
          <div v-if="$store.state.showItemBarcode && item.barcode != ''" class="item-barcode">
            {{ item.barcode }}
          </div>
          <div v-if="item.detail != ''" class="item-detail">
            {{ item.detail }}
          </div>
        </div>

        <div v-if="$store.state.descrIndex == 1">
          {{ item.descr1 }}
          <div v-if="$store.state.showItemBarcode && item.barcode != ''" class="item-barcode">
            {{ item.barcode }}
          </div>
          <div v-if="item.detail != ''" class="item-detail">
            {{ item.detail1 }}
          </div>
        </div>

        <div v-if="$store.state.descrIndex == 2">
          {{ item.descr2 }}
          <div v-if="$store.state.showItemBarcode && item.barcode != ''" class="item-barcode">
            {{ item.barcode }}
          </div>
          <div v-if="item.detail != ''" class="item-detail">
            {{ item.detail2 }}
          </div>
        </div> -->
      </div>

      <v-row class="item-footer-left">
        <div v-if="$store.state.menuImageAlignment == 'right'" class="pr-2">
          <div v-if="$store.state.orderMenu == 1" class="item-points">{{ item.redeemPoints }} pts</div>

          <div v-if="$store.state.orderMenu == 0">
            <div v-if="item.disabled && !$store.getters.storeMenuMode" class="item-disabled">
              {{ $t("item_disabled") }}
            </div>

            <div v-else-if="item.orderDisabled && !$store.getters.storeMenuMode" class="item-disabled">
              {{ $t("item_call_server") }}
            </div>

            <div v-else-if="item.soldout && !$store.getters.storeMenuMode" class="item-soldout">
              {{ $t("soldout") }}
            </div>

            <div v-else-if="item.discountedSub != 0" class="item-price">
              {{ item.discountedSub | currency }}
              <span v-if="item.sub != item.discountedSub" class="item-price-crossout">
                {{ item.sub | currency }}
              </span>
              <span class="mx-1 item-earn-points" v-if="$store.state.pointEnabled && item.earnPoints > 0">
                ( +{{ item.earnPoints }} pts )
              </span>
            </div>
          </div>
        </div>

        <v-col class="item-attribute">
          <v-icon v-if="item.favorite" class="attribute-icon-favorite">mdi-heart</v-icon>
          <v-icon v-if="item.attribute.includes('Vegetarian')" class="attribute-icon-veg">mdi-carrot</v-icon>
          <v-icon v-if="item.attribute.includes('Spicy2')" class="attribute-icon-spicy">mdi-chili-hot</v-icon>
          <v-icon v-else-if="item.attribute.includes('Spicy1')" class="attribute-icon-spicy">mdi-chili-medium</v-icon>
          <v-icon v-else-if="item.attribute.includes('Spicy')" class="attribute-icon-spicy">mdi-chili-mild</v-icon>
          <v-icon v-if="item.attribute.includes('Seafood')" class="attribute-icon-seafood">mdi-fish</v-icon>
          <v-icon v-if="item.attribute.includes('Peanut')" class="attribute-icon-peanut">mdi-peanut</v-icon>
          <img
            v-if="item.attribute.includes('Shellfish')"
            class="attribute-icon-seashell"
            src="@/assets/icon/shellfish-32x32.png"
          />
          <img
            v-if="item.attribute.includes('Dairy')"
            class="attribute-icon-dairy"
            src="@/assets/icon/dairy-fill-30x30.png"
          />
        </v-col>

        <!-- <div class="mx-1 item-earn-points" v-if="$store.state.pointEnabled && item.earnPoints > 0">( +{{ item.earnPoints }} pts )</div> -->

        <v-col v-if="$store.state.menuImageAlignment != 'right'" class="item-footer-right">
          <div v-if="$store.state.orderMenu == 1" class="item-points">{{ item.redeemPoints }} pts</div>

          <div v-if="$store.state.orderMenu == 0">
            <div v-if="item.disabled && !$store.getters.storeMenuMode" class="item-disabled">
              {{ $t("item_disabled") }}
            </div>

            <div v-else-if="item.orderDisabled && !$store.getters.storeMenuMode" class="item-disabled">
              {{ $t("item_call_server") }}
            </div>

            <div v-else-if="item.soldout && !$store.getters.storeMenuMode" class="item-soldout">
              {{ $t("soldout") }}
            </div>

            <div v-else-if="item.price + item.defOptValue != 0" class="item-price">
              <span class="mx-1 item-earn-points" v-if="$store.state.pointEnabled && item.earnPoints > 0"
                >( +{{ item.earnPoints }} pts )</span
              >
              <span v-if="item.sub != item.discountedSub" class="item-price-crossout">
                {{ item.sub | currency }}
              </span>
              {{ item.discountedSub | currency }}
            </div>
          </div>
        </v-col>
      </v-row>
    </v-col>

    <v-col
      v-if="
        $store.state.menuImageAlignment == 'right' &&
          ($store.state.menuImageVisible == 'show' || ($store.state.menuImageVisible == 'auto' && item.imageUri != ''))
      "
      :class="[
        $store.getters.categoryPosition == 'left' && $vuetify.breakpoint.xsOnly ? 'menu-img-box-xs' : 'menu-img-box',
        'pa-0',
        'align-self-center',
      ]"
    >
      <div v-if="item.imageUri == ''"></div>
      <img v-else :src="item.imageUri" />
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    item: null,
  },

  computed: {
    itemDescr() {
      if (this.item == null) return "";
      else if (this.$store.state.descrIndex == 1) return this.item.descr1;
      else if (this.$store.state.descrIndex == 2) return this.item.descr2;
      else return this.item.descr;
    },

    itemDetail() {
      if (this.item == null) return "";
      else if (this.$store.state.descrIndex == 1) return this.item.detail1;
      else if (this.$store.state.descrIndex == 2) return this.item.detail2;
      else return this.item.detail;
    },
  },

  methods: {
    itemClicked(item) {
      this.$emit("itemClicked", item);
    },
  },
};
</script>
